<template>
  <main class="password-layout">
    <v-container fluid fill-height>
      <v-layout
        column
        align-center
        justify-center>
        <v-flex xs12 sm8 md4>
          <router-view></router-view>
        </v-flex>

        <v-flex xs12 sm8 md4>
          <div class="logo">
            <img class="image" src="/static/images/base/new-docgo-logo.svg" alt="Logo DocGo">
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </main>
</template>

<script>
export default {
  name: 'PasswordLayout',
};
</script>

<style lang="scss">
.password-layout {
  .container {
    min-height: 100vh;
  }

  .card {
    margin-bottom: 2rem;
  }

  .logo {
    margin-top: 5rem;
    width: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/PasswordLayout.vue